import React from "react";
import {
    Box,
    Button,
    Container,
    Paper,
    Typography,
} from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        console.error("Error Boundary:", error);
        console.error("Component Stack:", info.componentStack);
    }

    handleReload = () => {
        window.location.reload();
    };

    render() {
        if (this.state.hasError) {
            return (
                <Container maxWidth="sm">
                    <Box
                        sx={{
                            minHeight: "100vh",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <Paper
                            elevation={4}
                            sx={{
                                p: 5,
                                borderRadius: 3,
                                textAlign: "center",
                                width: "100%",
                            }}
                        >
                            <ErrorOutlineIcon
                                color="error"
                                sx={{ fontSize: 72, mb: 2 }}
                            />

                            <Typography variant="h4" fontWeight={700} gutterBottom>
                                We'll Be Back Soon!
                            </Typography>

                            <Typography
                                variant="body1"
                                color="text.secondary"
                                sx={{ mb: 4 }}
                            >
                                We apologize for any inconvenience and appreciate your patience.
                            </Typography>

                            <Button
                                variant="contained"
                                size="large"
                                onClick={this.handleReload}
                            >
                                Reload Page
                            </Button>
                        </Paper>
                    </Box>
                </Container>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;